import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export default function useTileControls() {
  const compositorTiles = useSelector((state) => state.call.compositorTiles);
  const dispatch = useDispatch();

  const inRoomAnnouncementParticipants = useSelector(
    (state) => state.inRoomAnnoucement?.inRoomAnnouncementParticipants
  );

  const triggerCustomEvent = (eventName, data) => {
    const event = new CustomEvent(eventName, { detail: data });
    document.dispatchEvent(event);
  };

  useEffect(() => {
    compositorTiles.forEach(({ element, isApplication, participantId }) => {
      if (isApplication) {
        return;
      }
      const tileControls = element.querySelector(".video-tile-controls");
      if (tileControls) {
        const participant = inRoomAnnouncementParticipants?.find(
          (participantData) => {
            return participantData.particpantId === getScipId(participantId);
          }
        );

        const announcementControl = tileControls.querySelector(
          ".tile-control.announcement-button"
        );
        if (participant && !participant.isEnable) {
          if (announcementControl) {
            announcementControl.remove();
          }
          return;
        }
        if (participant && participant.isEnable) {
          let control = announcementControl;

          if (!control) {
            control = document.createElement("div");
            control.className = participant?.isVisble ? "tile-control announcement-button active" : "tile-control announcement-button";
            tileControls.insertBefore(
              control,
              tileControls.firstElementChild.nextElementSibling
            );
          }else{
            if(participant?.isVisble){
              control.classList.add("active");
            }else{
              control.classList.remove("active");
            }
          }

          control.onclick = () => {
            triggerCustomEvent("inRoomAnnouncementClicked", {
              detail: participant,
            });
          };
        } else {
          if (announcementControl) {
            announcementControl.remove();
          }
        }
      }
    });
  }, [compositorTiles, dispatch, inRoomAnnouncementParticipants]);

  const getScipId = (id) =>
    id?.substring?.(id.indexOf(":") + 1, id.indexOf(";"));
}
